require("./bootstrap");

import VueDatePick from 'vue-date-pick'
import VueProgressBar from "vue-progressbar";

require('./helpers')

Vue.use(VueProgressBar, {
  color: "#a6a9ff",
  failedColor: "#f9ac92",
  height: "2px",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true
});

import VueLazyLoad from 'vue-lazyload';

Vue.use(VueLazyLoad);

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

Vue.component('datepicker', require('../components/front/DatePicker.vue').default);

import VModal from "vue-js-modal";

Vue.use(VModal);

import VueTelInput from "vue-tel-input";

Vue.use(VueTelInput);
import VueToast from "vue-toast-notification";

Vue.use(VueToast, {
  // One of options
  position: "top-right",
  duration: 3000
});
import ReadMore from "vue-read-more";

Vue.use(ReadMore);
import rate from "vue-rate";

Vue.use(rate);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component("pagination", require("laravel-vue-pagination"));
Vue.component("sign-up", require("../components/front/SignUp.vue").default);
Vue.component("sign-in", require("../components/front/SignIn.vue").default);

//use-skill
Vue.component("edit-task", require("../components/front/task/EditTask").default);
Vue.component("tasks", require("../components/Tasks").default);
Vue.component("create-task", require("../components/front/task/CreateTask").default);
Vue.component("create-task-modal", require("../components/front/task/CreateTaskModal").default);
Vue.component("cancel-task", require("../components/front/task/CancelTask").default);

Vue.component("cancel-job", require("../components/front/job/CancelJob").default);
Vue.component("done-task", require("../components/front/task/DoneTask").default);
Vue.component("customer-review", require("../components/front/task/CustomerReview").default);

//business-profile
Vue.component("edit-business-info", require("../components/front/business-profile/EditBusinessInfo").default);
Vue.component("notification-setting", require("../components/front/dashboard/profile/NotificationSetting").default);
Vue.component("store-business-profile", require("../components/front/business-profile/StoreBusinessProfile").default);

//dashboard
Vue.component("message-notification", require("../components/front/dashboard/header/MessageNotification").default);
Vue.component("notification", require("../components/front/dashboard/header/Notification").default);

//message
Vue.component("message", require("../components/front/message/Message").default);
Vue.component("local-time", require("./../components/LocalTime.vue").default);
Vue.component("tel-input", require("./../components/TelInput.vue").default);
Vue.component("avatar", require("../components/front/dashboard/profile/Avatar").default);
Vue.component("personal-info", require("../components/front/dashboard/profile/PersonalInfo").default);
Vue.component("edit-password", require("../components/front/dashboard/profile/EditPassword").default);
Vue.component("business-info", require("../components/front/dashboard/profile/BusinessInfo").default);
Vue.component("profile-card", require("../components/front/dashboard/profile/Card").default);

Vue.component("dashboard-tasks", require("../components/front/task/DashboardTasks").default);

Vue.component("business-info", require("../components/front/dashboard/profile/BusinessInfo").default);
Vue.component("skills-editor", require("../components/front/dashboard/profile/SkillsEditor").default);
Vue.component("product", require("../components/front/dashboard/profile/Product").default);
Vue.component("add-promotion", require("../components/front/dashboard/profile/AddPromotion").default);
Vue.component("delete-promotion", require("../components/front/dashboard/profile/DeletePromotion").default);
Vue.component("promotions", require("../components/front/dashboard/profile/Promotions").default);
Vue.component("gallery-editor", require("../components/front/dashboard/profile/GalleryEditor").default);
Vue.component("video-editor", require("../components/front/dashboard/profile/VideoEditor").default);
Vue.component("make-offer", require("../components/front/offer/MakeOffer").default);
Vue.component("accept-offer", require("../components/front/offer/AcceptOffer").default);

// user profile
Vue.component("slider-profile", require("../components/front/publicprofile/SliderProfile").default);
Vue.component("get-quotes", require("../components/front/task/GetQuotes").default);
Vue.component("get-quotes-box", require("../components/front/GetQuotesBox").default);

Vue.component("become-trader", require("../components/BecomeTrader").default);
Vue.component("task-filter", require("../components/front/task/TaskFilter").default);
Vue.component("user-gallery", require("../components/front/user/UserGallery").default);
Vue.component("user-video", require("../components/front/user/UserVideo").default);
Vue.component("request-quotes", require("../components/front/RequestQuotes").default);
Vue.component("messenger", require("../components/front/messanger/messenger").default);
Vue.component("submit-task", require("../components/submit-task/submit-task").default);
Vue.component("auth", require("../components/auth/auth").default);
Vue.component("v-select", require("vue-select").default);
Vue.component("v-multi-select", require("vue-multiselect").default);
Vue.component("v-field", require("../components/form/field").default);
Vue.component("stripe-form",require("../components/front/pay/StripeForm").default)
Vue.component("v-tel", require("vue-tel-input").VueTelInput);
Vue.component("v-date-pick", VueDatePick);
Vue.component("v-header-notification", require("../components/header-notification").default);
Vue.component("v-header-messages", require("../components/header-messages").default);
Vue.component("v-header-profile", require("../components/header-profile").default);
Vue.component("v-header-categories", require("../components/header-categories").default);
Vue.component("v-link-preview", require("../components/front/LinkPreview").default);
Vue.component("v-user-gallery", require("../components/user-gallery").default);
Vue.component("v-promotions-page", require("../components/promotions-page").default);
Vue.component("v-promotion-item", require("../components/promotion-item").default);
Vue.component("v-cookie-contest", require("../components/cookie-contest").default);
Vue.component("v-follow-user", require("../components/follow-user").default);
Vue.component("v-remove-follower", require("../components/remove-follower").default);
Vue.component("v-follow-item", require("../components/front/dashboard/follow-item").default);
Vue.component("v-followers-card", require("../components/front/dashboard/followers-card").default);
Vue.component("v-followings-card", require("../components/front/dashboard/followings-card").default);
Vue.component("v-aside", require("../components/aside").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.prototype.$dispatch = window.$dispatch = (ev, params = {}) => {
  document.dispatchEvent(new CustomEvent(ev, {detail: params}))
}
Vue.prototype.$window = window


const app = new Vue({
  el: "#app",
  data: {
    api_token: null,
    get_quotes_modal_show: false,
    create_task_modal_show: false,
    get_quotes_category_id: null
  },
  methods: {
    openGetQuotesModal(category_id) {
      this.get_quotes_modal_show = true;
      this.get_quotes_category_id = category_id;
    }
  }
});
